// GlobalRadioGroup.js
import React from "react";
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

const GlobalRadioButtonWithValue = ({
  required = false,
  options = [],
  value,
  onChange,
  color = "#6A0DAD", // default purple
  row = true,
  getOptionLabel = (option) => option?.label || option,
  getOptionValue = (option) => option?.value || option,
  fontSize
}) => {



  return (
    <RadioGroup row={row} value={value} onChange={onChange}>
      {options.map((option, index) => {
      const optionValue = getOptionValue(option) ?? index;
        const optionLabel = getOptionLabel(option) ?? `Option ${index + 1}`;

        return (
         <FormControlLabel
  key={optionValue}
  value={optionValue}
  control={
    <Radio
      sx={{
        "& .MuiSvgIcon-root": { fontSize: 16 },
        color: color,
        "&.Mui-checked": { color: color },
      }}
    />
  }
  label={
    <Typography
      sx={{
        color: value === optionValue ? color : "inherit",
        fontWeight: value === optionValue ? 500 : 400,
        fontSize: fontSize ? fontSize : "13px",
        fontFamily:"Inter"
      }}
    >
      {optionLabel}
    </Typography>
  }
/>


        );
      })}
    </RadioGroup>
  );
};

export default GlobalRadioButtonWithValue;
